module.exports = __webpack_public_path__ + "static/media/the-story.c5bc0fcc.jpg";